<template lang="pug">
    .component-driver-reservations

        .action-bar
            .title
                h2 Driver Licenses
            .action
                i.fa.fa-plus-circle.fa-2x(@click="createDriverLicense")
        .column.row
            .columns.small-12.medium-8.medium-offset-2.driver-licenses(v-for="license in licenses")
                driver-licence(:type="'license-card-accordion'", :item="license")
</template>
<script type="text/babel">
    import KeplerBackofficeSdk from "src/lib/kepler/backoffice";
    import DriverLicence from "components/backoffice/DriverLicence";
    import MaggieHelper from "../../../maggieHelper";
    import DriverLicenseCreate from "../smartedits/DriverLicenseCreate.vue";

    export default {
        name: "DriverLicense",
        components: {
            DriverLicenseCreate,
            DriverLicence,
        },
        data() {
            return {
                licenses: []
            }
        },
        created() {
            KeplerBackofficeSdk.drivers.select(this.$route.params.id).getLicences((data) => {
                this.licenses = data
            })
        },
        methods: {
            createDriverLicense() {

                MaggieHelper.openRightPanel({
                    component: DriverLicenseCreate,
                    props: {
                        item: this.$route.params.id
                    }
                })
            }
        }
    }
</script>
<style lang="sass" rel="stylesheet/sass">
    .driver-licenses:first-child
        margin-top: 1rem
</style>



// WEBPACK FOOTER //
// DriverLicenses.vue?18257a08